module.exports = __webpack_public_path__ + "img/adm3.d9a98738.png";